export default __webpack_public_path__ + "c9499a8.png";